// Canonical SEUTRADE FINANCIAL SERVICES entity identity used across all binders/instruments.
export const FIRM = {
  name: "SEUTRADE FINANCIAL SERVICES",
  ein: "42-6951310",
  addressLines: ["213 N Market Street #1011", "Wilmington, DE 19801", "United States"],
  address: "213 N Market Street #1011, Wilmington, DE 19801",
  phone: "(877) 240-9128",
  trustee: "John Avery",
  officer: "Thomas Franklin",
  notary: "Terry Green",
  notaryState: "Delaware",
  pacer: "9272981",
  tcmm: { name: "Treasury Collateral Management & Monitoring (TCMM)", agent: "Federal Reserve Bank of St. Louis — Treasury Support Center", fax: "866-707-6574", phone: "888-568-7343", email: "TCMM_SC@stls.frb.org" },
};

export const firmContactLine = `EIN ${FIRM.ein} · ${FIRM.address}`;
